<template>
  <div>

<b-container class="" id="">
 <select id="officeT" @change="goFunction()" style="z-index:1;">
   <option value="customerCare" >এপিডিচিএল গ্ৰাহক সেৱা</option>
  <option value="kofficial" >মূখ্য বিষয়াসকলৰ (মুখ্য কাৰ্যালয়) যোগাযোগ</option>
   <option value="zone">ক্ষেত্ৰ কাৰ্যালয়:মণ্ডলসমূহৰ যোগাযোগ</option>
   <option value="circle">ক্ষেত্ৰ কাৰ্যালয়:চক্ৰসমূহৰ যোগাযোগ</option>
   <option value="division">ক্ষেত্ৰ কাৰ্যালয়:সংমণ্ডলসমূহৰ যোগাযোগ</option>
   <option value="subdivision">ক্ষেত্ৰ কাৰ্যালয়:উপ-সংমণ্ডলসমূহৰ যোগাযোগ</option>
   <option value="irca">ক্ষেত্ৰ কাৰ্যালয়:আই.আৰ.চি.এ. সমূহৰ যোগাযোগ</option>
   <option value="tc">ক্ষেত্ৰ কাৰ্যালয়:টি এণ্ড চি সংমণ্ডলসমূহৰ যোগাযোগ</option>
   <option value="agm">জিলাভিত্তিক এজিএম(প্ৰকল্প) সমূহৰ যোগাযোগ</option>
 </select>
</b-container>

</div>
</template>
<script>
export default
 {

  methods: {
    goFunction()
    {
      var ofc=document.getElementById('officeT').value;
    //  alert("Office::"+ofc);
      this.goto(ofc);
    },

  /*goto(refName) {
  // alert(refName);
     var element=document.getElementById(refName);
     element.scrollIntoView({  behavior: 'smooth', block: 'start', inline: 'start'  });

   }*/
  goto(refName) {
  
  document.querySelectorAll('.section-content').forEach(div => {
    div.style.display = 'none';
  });

  
  var element = document.getElementById(refName);
  element.style.display = 'block';


  element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' });

  // Button
  var btn_id = 'b' + refName;
  var btn = document.getElementById(btn_id);
  document.querySelector(".btn-color-active").classList.remove("btn-color-active");
  btn.classList.add("btn-color-active");
}


  }
}
</script>
<style scoped="true">
.custom-row {
  margin-right: 0;
  margin-left: 0;
  height:50px;
}

.btn-block{
  height:100%;
  width:100% !important;
  text-align: left;
  font-size: 0.9rem;
  font-weight: 500;
  letter-spacing: 0.2px;
  border:none;
  border-bottom:1px solid;

}


.btn-color{
  color: #616161    ;
  background-color: #ffff;
  border-color: #e0e0e0 ;
  transition:0.3s;
 }
.btn-color:hover
{
  color: #ffff;
  background-color: #0277bd     ;
  border-color: #0277bd     ;
}
.btn-color-active
{
  color: #ffff;
  background-color: #0288d1    ;
  border-color: #0288d1    ;
  box-shadow: none;
}

.side-n{
box-shadow: 0 -2px 15px 0 rgba(0, 0, 0, 0.2), 0 10px 10px 0 rgba(0, 0, 0, 0.19);
width:100%;

}
.container,.col
{
  padding-left:0;
  padding-right: 0;
}

</style>
